import React from "react";

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error("ErrorBoundary caught:", error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    background: "#0a0a1a",
                    color: "#d1d5db",
                    padding: "32px",
                    textAlign: "center",
                }}>
                    <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "white", marginBottom: "12px" }}>
                        Something went wrong
                    </h1>
                    <p style={{ fontSize: "14px", color: "#9ca3af", marginBottom: "24px", maxWidth: "480px" }}>
                        {this.state.error?.message || "An unexpected error occurred."}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: "10px 24px",
                            borderRadius: "12px",
                            border: "1px solid rgba(153, 69, 255, 0.4)",
                            background: "rgba(153, 69, 255, 0.15)",
                            color: "#c4b5fd",
                            cursor: "pointer",
                            fontSize: "14px",
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
